export const triggerSelectionHaptic = (browserWindow = typeof window === "undefined" ? undefined : window) => {
  try {
    const result = browserWindow?.WagedWarNative?.haptics?.selection?.();

    if (result && typeof result.then === "function") {
      Promise.resolve(result).catch(() => {});
    }
  } catch (error) {
    // Native haptics are an optional enhancement and must never affect selection.
  }
};
